
export const collections = [
  {
    id: 1,
    name: "Women's Signature Collection",
    subtitle: "Timeless Elegance",
    price: "From $299",
    image:
      "https://public.readdy.ai/ai/img_res/9767567b2b0f8062864c6e9f281b2ecb.jpg"
  },
  {
    id: 2,
    name: "Women's Evening Wear",
    subtitle: "After Dark Glamour",
    price: "From $399",
    image:
      "https://readdy.ai/api/search-image?query=Stunning%20women%20evening%20gown%20collection%20featuring%20elegant%20formal%20dress%20in%20warm%20gold%20and%20olive%20tones%20on%20simple%20clean%20warm%20beige%20background%20professional%20fashion%20photography%20high-end%20couture%20style%20sophisticated%20glamorous%20aesthetic%20studio%20lighting&width=600&height=800&seq=abexia-women-evening-v2&orientation=portrait"
  },
  {
    id: 3,
    name: "Women's Casual Chic",
    subtitle: "Everyday Luxury",
    price: "From $149",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20women%20casual%20chic%20fashion%20collection%20featuring%20modern%20relaxed%20luxury%20outfit%20in%20warm%20earth%20tones%20beige%20cream%20and%20olive%20on%20simple%20clean%20warm%20background%20professional%20fashion%20photography%20high-end%20boutique%20style%20effortlessly%20elegant%20aesthetic%20studio%20lighting&width=600&height=800&seq=abexia-women-casual-v2&orientation=portrait"
  },
  {
    id: 4,
    name: "Kids Party Bags & Gifts",
    subtitle: "Celebrate in Style",
    price: "From $19",
    image:
      "https://readdy.ai/api/search-image?query=Beautiful%20colorful%20children%20party%20gift%20bags%20and%20souvenirs%20collection%20featuring%20cute%20transparent%20frosted%20bags%20with%20ribbon%20bows%20and%20colorful%20shredded%20paper%20filling%20elegant%20kids%20party%20favors%20on%20warm%20beige%20background%20professional%20product%20photography%20playful%20yet%20sophisticated%20aesthetic%20studio%20lighting&width=600&height=800&seq=abexia-party-bags-v2&orientation=portrait"
  }
];

export const partyBagProducts = [
  {
    id: 1,
    name: "Frosted Ring Handle Bag",
    description: "Elegant frosted PVC bag with leather ring handle and satin bow",
    price: "$12.99",
    colors: ["Rose", "White", "Blue", "Brown"],
    image:
      "https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/e133db203465e4d8ac244d8f060fa689.jpeg"
  },
  {
    id: 2,
    name: "Rainbow Confetti Bag",
    description:
      "Transparent party bag filled with rainbow confetti and treats",
    price: "$9.99",
    colors: ["Pink", "Gold", "Silver"],
    image:
      "https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/3c5c4d0a9a2fd17cc7a580d26dac2dc0.jpeg"
  },
  {
    id: 3,
    name: "Princess Gift Set",
    description:
      "Curated princess-themed party bag with tiara, wand and treats",
    price: "$18.99",
    colors: ["Pink", "Lavender"],
    image:
      "https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/e32b858cbeb2f43a1bf157cb3115871e.jpeg"
  },
  {
    id: 4,
    name: "Safari Adventure Bag",
    description:
      "Fun animal-themed party bag with plush keychain and goodies",
    price: "$14.99",
    colors: ["Green", "Brown", "Orange"],
    image:
      "https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/70b12440de769f2586ff287c4d50a6d7.jpeg"
  },
  {
    id: 5,
    name: "Unicorn Dream Bag",
    description:
      "Magical unicorn-themed party bag with sparkle accessories",
    price: "$16.99",
    colors: ["Pastel Pink", "Pastel Blue"],
    image:
      "https://readdy.ai/api/search-image?query=Magical%20unicorn%20themed%20children%20party%20gift%20bag%20with%20sparkly%20accessories%20and%20colorful%20treats%20in%20beautiful%20frosted%20bag%20with%20pastel%20ribbon%20on%20warm%20beige%20background%20professional%20product%20photography%20whimsical%20dreamy%20aesthetic%20studio%20lighting&width=400&height=400&seq=abexia-unicorn-bag-v2&orientation=squarish"
  },
  {
    id: 6,
    name: "Superhero Power Pack",
    description:
      "Action-packed party bag with mask, stickers and surprises",
    price: "$15.99",
    colors: ["Red", "Blue", "Yellow"],
    image:
      "https://readdy.ai/api/search-image?query=Fun%20superhero%20themed%20children%20party%20gift%20bag%20with%20colorful%20mask%20stickers%20and%20surprise%20toys%20in%20bright%20decorated%20bag%20on%20warm%20beige%20background%20professional%20product%20photography%20energetic%20playful%20aesthetic%20studio%20lighting&width=400&height=400&seq=abexia-superhero-bag-v2&orientation=squarish"
  }
];
